<template>
  <b-overlay :show="show" opacity="1" rounded="sm" :fixed="show" no-wrap variant="primary rounded-0" spinner-variant="white" >


    <template  v-if="way=='Lover'?true:false"  v-slot:overlay>

      <b-spinner  variant="primary" ></b-spinner>

    </template>

    <template v-else-if="way=='Normal'?true:false" v-slot:overlay>
      <div class="loader">
        <div class="inner one"></div>
        <div class="inner two"></div>
        <div class="inner three"></div>
      </div>
    </template>

    <template v-else-if="way==''?true:false" v-slot:overlay>
      <b-spinner  variant="white" ></b-spinner>
    </template>

  </b-overlay>
</template>

<script>

export default {
  name: 'PaymentModel',
  props: {
    puid:String,
    show:Boolean,
    way:String,
  },
  computed:{

  },
  data() {
    return {

    }
  },
  mounted(){


  },
  methods: {


  }
}
</script>
<style>
  .loader {
    position: absolute;
    top: calc(50% - 60px);
    left: calc(50% - 60px);
    width: 120px;
    height: 120px;
    border-radius: 50%;
    perspective: 800px;
  }

  .inner {
    position: absolute;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .inner.one {
    left: 0%;
    top: 0%;
    animation: rotate-one 1s linear infinite;
    border-bottom: 3px solid #EFEFFA;
    color: white;
    text-shadow: 2px 2px 4px #fff4eb;
  }

  .inner.two {
    right: 0%;
    top: 0%;
    animation: rotate-two 1s linear infinite;
    border-right: 3px solid #EFEFFA;
  }

  .inner.three {
    right: 0%;
    bottom: 0%;
    animation: rotate-three 1s linear infinite;
    border-top: 3px solid #EFEFFA;
  }

  @keyframes rotate-one {
    0% {
      transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg);
    }
    100% {
      transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg);
    }
  }

  @keyframes rotate-two {
    0% {
      transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg);
    }
    100% {
      transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg);
    }
  }

  @keyframes rotate-three {
    0% {
      transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg);
    }
    100% {
      transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg);
    }
  }
</style>
